export default __webpack_public_path__ + "static/logo1-bda8d92af82350f1e821c7f3dbec010b.png";